module.exports = __webpack_public_path__ + "img/3H.cd9144e9.svg";